<script setup>
import { computed } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';
import Button from 'dashboard/components-next/button/Button.vue';
import ExpandableText from 'dashboard/components/ui/ExpandableText.vue';

const props = defineProps({
  cannedItem: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(['edit', 'delete']);

const teams = useMapGetter('teams/getTeams');

const teamNames = computed(() => {
  if (!props.cannedItem.team_ids || props.cannedItem.team_ids.length === 0) {
    return [];
  }
  return teams.value
    .filter(team => props.cannedItem.team_ids.includes(team.id))
    .map(team => team.name);
});
</script>

<template>
  <div
    class="flex flex-col w-full gap-0 outline-1 outline outline-n-container rounded-xl bg-n-solid-1 px-6"
  >
    <div class="flex items-center justify-between gap-2 py-4">
      <span class="text-base font-mono font-medium text-n-slate-12">
        /{{ cannedItem.short_code }}
      </span>
      <div class="flex items-center gap-1 shrink-0">
        <Button
          v-tooltip.top="$t('CANNED_MGMT.EDIT.BUTTON_TEXT')"
          icon="i-lucide-pen"
          slate
          xs
          faded
          @click="emit('edit', cannedItem)"
        />
        <Button
          v-tooltip.top="$t('CANNED_MGMT.DELETE.BUTTON_TEXT')"
          icon="i-lucide-trash-2"
          xs
          ruby
          faded
          @click="emit('delete', cannedItem)"
        />
      </div>
    </div>

    <div class="py-4">
      <div class="rounded-lg outline outline-1 outline-n-weak">
        <ExpandableText
          :content="cannedItem.content"
          :char-limit="200"
          :expand-text="$t('CANNED_MGMT.LIST.EXPAND')"
          :collapse-text="$t('CANNED_MGMT.LIST.COLLAPSE')"
        />
      </div>
    </div>

    <div v-if="teamNames.length > 0" class="flex flex-wrap gap-1.5 py-3">
      <span
        v-for="name in teamNames"
        :key="name"
        class="inline-flex items-center px-2.5 py-0.5 text-xs font-medium text-n-slate-11 bg-n-alpha-2 rounded-md"
      >
        {{ name }}
      </span>
    </div>
  </div>
</template>
